var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('router-view',{attrs:{"id":"maincontent"}}),_c('Footer'),_c('a',{staticClass:"scroll-top off",attrs:{"href":"javascript:void(0)"}},[_c('span',{staticClass:"screen-reader-text"},[_vm._v(_vm._s(_vm.$t("button.goToTop")))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }